const user = {
  state: {
    miniEnv: false, // 是否小程序环境
    //默认游客身份token，不要删除
    token: 'NBGy6GkK0j7YaQQy1mD5tnN3Zu9ep7iLOc5INKlI6ZnGqTTtK0xlBOZ/bJUKrMMzPl+nyO+tHBwcMC0MmDanUwBDAbfWGBfs24mV6zizKOKsIyWRblarOyYWOTW4MnjK8/lzo80KxYaPNqn7kEkK//nVtIRPv056DZfUsff7LLoZYPumnCROuD/UP5dbynw77h18E1SncYIPukUmWlVAsHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+EFuBNSGv7jS/EiP8TMmzPH6W9BOJ3fXHPruzmc9hoL3VlmMrXj81gqoCVvYEzHBv5Y/1uPajeHYAhdhXBMqQJg=',
    // token: 'GW1yXNm1dXScd12i7KwdZwphOue011xko5UvLSZp3yyCC7zkQpfGXFRymLv10xV3gQfnU/kCaJV3DopL+NnYcRzO9CQr2cON4zJgO1fk0jVnELg7oSOimeJuWhBc8FyztuzxWL8QkbH5IYziLCLbuv9vXE4AygmMh5vOMqQ1qQK+hM/rDnGqB5R2pHgeKLkTrc42+z6uAcmQDZvpcEQ4Lm/ejLm8w8ombPEFsOc8Qd9YCs78lWlJov0QcOXrsr8GsDXLs6sjx+PwilRpoHCAxl+DENTClW5ewEk3CZKpLg2T4Kvb4VN31UBz9FD9iCo3aoGmEHUhzs9t9LPhi6DSagY1xfTemv/cjTXX1P5JN+YZr1qSiZ6zEG8v3vrUREcEbWTRlmMsL/qTNrEQPodwu9v/wQOfuEcUSyxbUQKeqSBOufZpaCtNw7FFm92UKQNZMgTm6egkBtLazMlJo1kLuy1hVmtPeTLCGiarTPudiFOyLNqHkwtaHPQ5wxGW29/X/KSFDfIMW+ljeBQknpXmcA==',
    exhibitorId: 'e06da62d10ab48a893fae2159de4cfb4',  // 展商ID
    exhibitionId: 'd2f643e206fd47fe943f3c362799fdf2',  // 展会ID
    appId: '', //APPID
    languageType: "cn",
    subjectType: 'VISITOR', // 身份角色
    terminal: "",
    from: '',  // 记录来源
    useraccount_id: '',
  },
  mutations: {
    changeToken(state, token) {
      state.token = token
    },
    changeExhibitorId(state, exhibitorId) {
      state.exhibitorId = exhibitorId
    },
    changeExhibitionId(state, exhibitionId) {
      state.exhibitionId = exhibitionId
    },
    changeAppID(state, appId) {
      state.appId = appId
    },
    changeSubjectType(state, subjectType) {
      state.subjectType = subjectType
    },
    changeFrom(state, from) {
      state.from = from
    },
    changeUseraccountId(state, token) {
      state.useraccount_id = token
    },
    changeLanguageType(state, languageType) {
      state.languageType = languageType
    },
    changeTerminal(state, terminal) {
      state.terminal = terminal
    },
    changeMiniEnv(state, miniEnv) {
      state.miniEnv = miniEnv
    }
  }
}

export default user;